export default {
  'union.banner_desc': 'Up to 60% rebate ratio, sharing Biconomy growth benefits',
  'union.banner_title': 'Join Our Special Referral Program',
  'learn_more': 'Learn more',
  'apply_now': 'Apply Now',
  'union.banner_btn': 'login to your dashboard',
  'union.banner_list_title_1': 'Generous Rebates',
  'union.banner_list_desc_1': 'Level up and get up to 60% rebates',
  'union.banner_list_title_2': 'Sharing Benefits',
  'union.banner_list_desc_2': 'Become top ranked and share BIT equivalent to 5000$',
  'union.banner_list_title_3': 'Referral Rewards',
  'union.banner_list_desc_3': 'Get referral reward in BIT equivalent to 500$',
  'union.content_title': 'Are you a crypto enthusiast that belongs to one of the following groups?',
  'union.about_title_1': 'Social media and crypto community activists',
  'union.about_title_2': 'Industry experts institutions and professionals',
  'union.about_title_3': 'Growth hackers and people skilled in lead generation',
  'union.about_desc_1': 'People that post regularly about crypto and/or are  active in crypto communities with 1000+ members',
  'union.about_desc_2':
    'Well-known institutions, traders, investment consultants, derivatives agents, investment advisors, stock brokers, chambers of commerce, associations, etc',
  'union.about_desc_3': 'People skilled in any channel/platform that can potentially attract new users to Biconomy',
  'union.condition_title': 'Fulfill The Conditions To Level Up',
  'union.condition_desc':
    'Referrers that reach Level 3 in every quarter and rank top 5 in terms of the number of people invited can share the equivalent of $5000 in BIT benefits. If the referee passed a quarterly assessment successfully, the referrer is entitled to a one-time referral reward of $500 equivalent to BIT. 10 referral rewards will be set every quarter, on a first-come-first-served basis.',
  'union.rebate': '{num}% Rebate',
  'union.rebate_desc': 'Bring {num} new users in 3 months, of which {spot} spot/contract trading users',
  'union.rebate_desc_2': 'Bring new users that accumulate {num}M USD in 3 months',
  'or': 'or',
  'union.faq_title': 'Make Sure To Comply with Program Terms',
  'union.faq_title_1': 'Biconomy Channel Obligations and Code of Conduct',
  'union.faq_desc_1':
    'Channel partners are required to regularly promote acquisition on their own platforms to attract new users, Biconomy will periodically evaluate based on the number of new users and newly increased transaction volume from the channel on a quarterly basis. The standards are shown in the table above. Those who failed to meet the standard will have commission rebate rights reduced until the Affiliate status is lifted.',
  'union.faq_desc_2':
    'Channel partners are required to abide by the Biconomy brand usage rules, and are not allowed to use the Biconomy brand without authorization. Biconomy does not provide credit endorsements on any action taken by the Channel partners.',
  'union.faq_title_2': 'Recruiting target',
  'union.faq_desc_3':
    'If you meet the following criteria, you can apply for Level 1 rebate, which will be automatically upgraded at the end of each quarter according to the invited users.',
  'union.faq_desc_4': 'Social media followers or community/community users: 1000+',
  'union.faq_desc_5':
    'Famous institutions in the industry, famous traders, investment advisors, derivatives agents, investment advisors, stockbrokers, chambers of commerce, associations, etc.',
  'union.faq_desc_6': 'Other channels that are judged by Biconomy to have the ability to attract new users.',
  'others': 'Others',
  'union.faq_desc_7':
    'Registered users who have cancelled and re-registered are regarded as invalid invited users, and no trading rebates are provided.',
  'union.faq_desc_8': 'Invite sub-accounts are not counted in the rebate.',
  'union.faq_desc_9': 'Channel traders can get rebates without holding BIT.',
  'level_1': 'level 1',
  'level_2': 'level 2',
  'level_3': 'level 3',
};
